import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";

const researchItems = [
  {
    title: "Agentic Orchestration Engines",
    body: "We are developing advanced multi-agent systems where specialised AI entities collaborate in real-time. This research focuses on long-running task reliability, allowing our systems to handle complex, multi-step goals autonomously.",
  },
  {
    title: "Client-Side Neural Inference",
    body: "To ensure data privacy and zero latency, we are pioneering on-device AI. By running optimised neural networks directly in the browser, we eliminate round-trip server delays and keep sensitive data local.",
  },
  {
    title: "Neuromorphic-Inspired Interfaces",
    body: "Our R&D team is exploring interface designs that anticipate user intent through predictive patterns and micro-interaction analysis — moving from reactive to proactive digital experiences.",
  },
  {
    title: "Predictive QA & Self-Healing Architecture",
    body: "Our AI models monitor live system health, simulating edge-case scenarios to identify and auto-patch vulnerabilities before they impact users.",
  },
];

const pillars = [
  {
    label: "Autonomous Workflows",
    desc: "Our AI systems proactively identify inefficiencies before they impact your bottom line.",
  },
  {
    label: "Explainable AI (XAI)",
    desc: "You won't just get an answer — you'll see the logic and data sources behind every AI-generated recommendation.",
  },
  {
    label: "Continuous Evolution",
    desc: "Our models refine themselves in real-time, ensuring that our technology grows alongside your business needs.",
  },
];

const AI: React.FC = () => {
  return (
    <Container maxWidth="md" style={{ marginTop: "50px", marginBottom: "80px", fontFamily: "Roboto, sans-serif", padding: "20px" }}>
      <Typography variant="h4" style={{ fontWeight: "bold", marginBottom: "8px" }}>
        AI &amp; Innovation
      </Typography>
      <Typography variant="body1" style={{ color: "#555", marginBottom: "40px", lineHeight: 1.8 }}>
        At DH Technologies, we leverage artificial intelligence and smart-building automation to increase asset value and
        operational efficiency. Our work spans autonomous workflows, on-device inference, and intelligent infrastructure.
      </Typography>

      <Divider style={{ marginBottom: "40px" }} />

      <Typography variant="h5" style={{ fontWeight: "bold", marginBottom: "24px" }}>
        Research Focus Areas
      </Typography>

      {researchItems.map((item, i) => (
        <Box key={i} style={{ marginBottom: "28px" }}>
          <Typography variant="h6" style={{ fontWeight: "bold", marginBottom: "8px" }}>
            {item.title}
          </Typography>
          <Typography variant="body1" style={{ color: "#555", lineHeight: 1.8 }}>
            {item.body}
          </Typography>
        </Box>
      ))}

      <Divider style={{ margin: "40px 0" }} />

      <Typography variant="h5" style={{ fontWeight: "bold", marginBottom: "24px" }}>
        Our Principles
      </Typography>

      {pillars.map((p, i) => (
        <Box key={i} style={{ marginBottom: "20px" }}>
          <Typography variant="h6" style={{ fontWeight: "bold", marginBottom: "6px" }}>
            {p.label}
          </Typography>
          <Typography variant="body1" style={{ color: "#555", lineHeight: 1.8 }}>
            {p.desc}
          </Typography>
        </Box>
      ))}
    </Container>
  );
};

export default AI;
